import axios from '@util/axios'

export const CompanyService = {
  list: (params = {}, options = {}) =>
    axios({
      ...options,
      url: `/company/`,
      params
    }),
  create: (newData, options = {}) =>
    axios({
      ...options,
      url: `/company/`,
      method: 'POST',
      data: newData
    }),
  read: (id, options = {}) =>
    axios({
      ...options,
      url: `/company/${id}/`
    }),
  patch: (id, updatedDataPart, options = {}) =>
    axios({
      ...options,
      url: `/company/${id}/`,
      method: 'PATCH',
      data: updatedDataPart
    }),
  put: (id, updatedData, options = {}) =>
    axios({
      ...options,
      url: `/company/${id}/`,
      method: 'PUT',
      data: updatedData
    }),
  delete: (id, options = {}) =>
    axios({
      ...options,
      url: `/company/${id}/`,
      method: 'DELETE'
    }),
  lightweight: (params = {}, options = {}) =>
    axios({
      ...options,
      url: '/company/lightweight/',
      params
    })    
}
